module.exports = require("@pb/kit-stylus/config.json");